// import toggleFramework from "../util/toggle-framework";
import smallcode from "../util/smallcode";
import {/*visibleInElement,*/ lazyload/*, getCoords*/} from "../util/lazyload";
import autorefresh from "../util/autorefresh";
import sliderTh from "../util/sliderTh";
import toggleFramework from "../util/toggleFramework";

export default {
    init() {
        // JavaScript to be fired on all pages
        smallcode.init();
        let who = navigator.sayswho;
        if (who[0]) {
            if (!Array.isArray(who)) {
                who = who.split(" ");
            }
            console.log(who);
            $("body").addClass("is-" + who[0].toLowerCase());
        }
        lazyload(false);

    },

    finalize() {
        autorefresh.finalize(global);
        toggleFramework.finalize();


        let $body = $('body');
        let ajaxURL = global["global"]["ajaxurl"];
        let selectedCats = [];
        let perPage = $("#per_page").val() || 4;
        let $galElems = $(".galerieElems");


        function goToNextSlide() {
            $galElems = $(".galerieElems");
            if ($galElems.length && !$galElems.hasClass("hovered")) {
                $galElems.find(".slide-next").trigger("click");
            }
            if ($galElems.hasClass("hovered")) {
                console.log("prevented because hovered");
            }
        }


        sliderTh.init($body);


        $(".widget-title").each(function () {
            if (!$(this).find("span").length) {
                $(this).wrapInner("<span class='js-added'></span>");
            }
        });


        /**
         * Define SEO friendly method for multiple links to same dest.
         * Example : <div class="link_master"><a href="#" class="link">MAIN LINK</a><img class="link_slave" /></div>
         */

        let firstClick = true;
        $body.on('click', '.link-slave', function () {
            let $master = $(this).parents('.link-master');
            let $reallink = $($master).find('a.link');
            $reallink[0].click();
        }).on("click", ".actualites-selector a", function (e) {
            e.preventDefault();
            let $my = $(this);


            let $wrapper = $my.parents(".actualites-wrapper");
            let $display = $wrapper.find(".actualites-remote");
            $wrapper.addClass('loading');
            let $li = $my.parents(".cat-item");
            let idCat = $li.attr("class").replace("cat-item-", "").replace("selected", "").replace("cat-item", "").trim();


            if (!$my.hasClass("selected")) {
                selectedCats.push(idCat);
            } else {
                selectedCats[idCat] = undefined;
            }
            let stringified = JSON.stringify(selectedCats);
            console.log(selectedCats, stringified);


            $.ajax({
                url: ajaxURL,
                data: {
                    "action": "get_posts_remote",
                    "category_id": stringified,
                    "per_page": perPage,
                },
                success(response) {
                    $display.html(response);
                    lazyload();
                    $my.toggleClass("selected");
                    $li.toggleClass("selected");
                    $wrapper.removeClass('loading');
                },
            });


        }).on('click', '.actualites-see-more-wrapper a', function (e) {
            e.preventDefault();
            let $my = $(this);
            perPage *= 1;
            // let $parent = $my.parents(".actualites-see-more-wrapper");
            let $wrapper = $my.parents(".actualites-wrapper");
            let $display = $wrapper.find(".actualites-remote");
            $wrapper.addClass('loading');
            let stringified = JSON.stringify(selectedCats);
            perPage += 4;

            console.log("see-more get_posts_remote", $wrapper, $display, perPage, selectedCats);
            $.ajax({
                url: ajaxURL,
                data: {
                    "action": "get_posts_remote",
                    "category_id": stringified,
                    "per_page": perPage,
                },
                success(response) {
                    $display.html(response);
                    lazyload();

                    $wrapper.removeClass('loading');
                    console.log(response);
                },
            });
        }).on("click", ".teaser-coachs .coach", function (e) {
            let $my = $(this);
            let $myImage = $(this).find(".image-wrapper");
            let $parent = $my.parents(".post-in-loop");
            let id = $my.data("id");
            let $outerWrapper = $my.parents(".coach-outer-wrapper");
            if ($outerWrapper.hasClass("international")) {
                e.preventDefault();
            }

            let $contentCoach = $outerWrapper.find(".content-coachs");
            let $contentCoachInnerWrapper = $contentCoach.find(".content-coachs-inner-wrapper");
            let $teaserCoachs = $outerWrapper.find(".teaser-coachs");
            let $loopSelected = $contentCoach.find(".post-in-loop-" + id);
            let $cursor = $contentCoach.find(".cursor");

            $parent.siblings(".post-in-loop").find(".coach").removeClass("current");
            $my.addClass("current");

            $outerWrapper.addClass("toggle");
            $contentCoach.addClass("toggle");
            $loopSelected.removeClass('hidden').siblings(".post-in-loop").addClass('hidden');

            let mybottom = $myImage.position().top + $myImage.height();
            let centerX = $myImage.position().left + $myImage.width() / 2;
            let left = centerX / $teaserCoachs.width() * 100;
            let margin = 10;
            $contentCoach.css("top", mybottom + margin + "px");
            if ($cursor.parents(".international").length) {
                console.log('international');
                // let quarter = 1;
                // let outwidth = $outerWrapper.width();
                let newLeft = $myImage.offset().left + $myImage.width() / 2;
                let perline = 0;
                //
                $teaserCoachs.find(".coach").each(function () {
                    let toptocheck = $(this).position().top;
                    if (toptocheck === 0) {
                        ++perline;
                    }
                });
                // let currentIndexInline = $parent.index() % perline;
                // let morehalf = false;
                // if (currentIndexInline >= perline / 2) {
                //     morehalf = true;
                //
                // }
                // console.log(perline, currentIndexInline, morehalf);

                switch (perline) {
                    case 4:
                    case 5: {
                        if (left > 50) {
                            $contentCoachInnerWrapper.css("right", "0");
                            $contentCoachInnerWrapper.css("left", "auto");
                        } else {
                            $contentCoachInnerWrapper.css("left", "12.5%");
                            $contentCoachInnerWrapper.css("right", "auto");
                        }
                        break;
                    }
                }

                $cursor.offset({"left": newLeft - 20});
                if (firstClick) {
                    setTimeout(function () {
                        console.log("firstclick", newLeft);
                        $cursor.offset({"left": newLeft - 20});
                    }, 100);
                }
                firstClick = false;
            } else {
                $cursor.css("left", left + "%");
            }


            $cursor.css("margin-left", '-15px');

            // console.log("coachClicked", left);

            $cursor.removeClass("hidden");

            // let top = $contentCoach.position().top - $cursor.height() / 2 + 6;
            // let left = $my.position().left + $my.width() / 2 - 6;
            // $cursor.css({"top": top, "left": left});

            // console.log("click coach", id, top, left);
        }).on("click", ".nav-primary.toggle .menu-item-has-children > a", function (e) {
            console.log("itemChildrenClick");
            e.preventDefault();
            let $mySubmenu = $(this).siblings(".sub-menu");
            let add = true;
            if ($mySubmenu.hasClass("toggle")) {
                add = false;
            }

            $(this).parents(".nav-primary").find(".sub-menu").removeClass('toggle');
            if (add) {
                $(this).siblings(".sub-menu").addClass("toggle");
            }


        }).on("click", ".close-button", function () {
            let $my = $(this);
            let $cc = $my.parents(".content-coachs");
            let $cow = $my.parents(".coach-outer-wrapper");
            if ($cc.length) {
                $cc.removeClass("toggle");
                $cc.find(".cursor").addClass('hidden');
            }
            if ($cow.length) {
                $cow.removeClass("toggle");
            }
        }).on("click", ".wpim-marker__icon", function () {
            let value = $(this).find("i").html();
            console.log(value);
        }).on("click", '.slide', function () {
            let direction = false;
            let $my = $(this);
            let $track = $my.siblings(".slide-track");
            if ($track.length) {
                if ($my.hasClass("slide-next")) {
                    direction = "next"
                }
                if ($my.hasClass("slide-prev")) {
                    direction = "prev"
                }

                swipeTrack($track, direction, "100vw");
            }

        }).one("mousemove", function () {
            console.log("one mousemove");
            setInterval(goToNextSlide, 8000);
        }).on("mouseenter", ".galerieElems", function () {
            $(this).addClass("hovered");
        }).on("mouseenter", ".galerieElems *", function () {
            $(this).closest(".galerieElems").addClass("hovered");
        }).on("mouseout", ".galerieElems", function () {
            $(this).removeClass("hovered");
        });

        function swipeTrack($track, direction) {

            let margin = 'margin-left';
            if ($track.data("direction") === "vertical") {
                margin = 'margin-top'
            }

            let unit = "px";
            let dataUnit = $track.attr("data-unit");
            if (dataUnit) {
                unit = dataUnit
            }

            let number = 1;
            let dataNumber = $track.attr("data-number") * 1;
            if (dataNumber) {
                number = dataNumber
            }


            let lastIndex = $track.find(".post-in-loop:last-of-type").attr("data-index");
            let currentSlide = $track.find(".current");
            if (!currentSlide.length) {
                currentSlide = $track.find(".index-0");
            }

            let index = currentSlide.attr("data-index") * 1;
            // let newIndex = index;


            switch (direction) {
                case "next":
                    ++index;
                    break;
                case "prev":
                    --index;
                    break;
                default: {
                    console.log("No direction");
                    break;
                }
            }
            if (index < 0) {
                index = lastIndex;
            }
            if (index > lastIndex) {
                index = 0;
            }

            let newNumber = number * index * -1;
            // console.log("swipeTrack", number, unit, index, lastIndex, direction);
            let unity = newNumber + unit;
            $track.css(margin, unity);
            $track.find(".current").removeClass("current");
            $track.find(".index-" + index).addClass("current");
            // lazyload(false);
        }
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js